import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function EconomizarHoobuyPage() {
  return <BlogArticleLayout slug="como-economizar-hoobuy" />;
}